// .email_block_paragraph ol > li::before {
//     list-style: none;
//     content: counter(list-0, ) '. ';
// }

export default {
    css: `
    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
    * {
        box-sizing: border-box;
    }
    a,
    a:hover,
    a:focus,
    a:visited,
    a:active {
        text-decoration: none;
    }
    ul, ol {
        margin: 0;
    }
    h1,
    h2,
    h3,
    h4,
    h5 {
        margin: 0;
        padding: 0;
    }
    a,
    svg path,
    svg rect {
        transition: 0.15s all ease-in-out;
    }

    /**/
    .email_block_paragraph ol, .email_block_paragraph ul {
        margin: 0;
    }
    .email_block_paragraph ul {
        padding-left: 0;
    }

    /*.email_block_paragraph li::before {
        display: inline-block;
        white-space: nowrap;
        width: 1.2em;
        margin-left: 0em;
        margin-right: 0.3em;
        text-align: right;
    }*/
    
    .email_btn {
        display: flex;
        font-weight: 500;
        font-size: 14px;
        line-height: normal;
        letter-spacing: 0.02em;
        color: #F6F9FE;
        background: #4368E0;
        border-radius: 4px;
        padding: 8px 30px;
        transition: 0.15s all ease-in-out;
        cursor: pointer;
        border: none;
        outline: none;
    }
    .email_btn:active,
    .email_btn:hover {
        background: #3959C1;
        color: #F6F9FE;
    }
    .email_btn.brdr_btn {
        color: #4368E0;
        background: #FFFFFF;
        border: 1px solid #4368E0;
        padding: 8px 30px;
    }
    .email_btn.brdr_btn:hover,
    .email_btn.brdr_btn:active {
        background: #F6F9FE;
        color: #4368E0;
    }
    .element_wrpr img {
        max-width: 100%;
    }
    .email_social_element {
        text-align: center;
        width: 100%;
    }
    .email_social_element li {
        display: inline-block;
        margin: 0 15px;
    }
    .email_social_element li a {
        transition: .3s;
        display: block;
    }
    .email_social_element li a:hover {
        opacity: .7;
    }
    .email_social_element li a img {
        width: 30px;
        height: 30px;
        min-width: 30px;
        min-height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .email_menu_element {
        text-align: center;
        margin: -5px;
    }
    .email_menu_element li {
        margin: 5px;
        display: inline-block;
        text-decoration: inherit;
    }
    .email_menu_element li a {
        display: block;
        text-decoration: inherit;
        color: inherit;
        font-weight: inherit;
        font-size: inherit;
    }
    .email_block_paragraph img {
        max-width: 100%;
    }
    .email_block_paragraph .ql-align-center {
        text-align: center;
    }
    .email_block_paragraph .ql-align-right {
        text-align: right;
    }
    .email_block_paragraph .ql-align-justify {
        text-align: justify;
    }
    .email_block_paragraph p {
        margin: 0;
    }
    .email_block_paragraph {
        width: 100%;
    }
    .element.img_elem_wrpr, .element.image {
        width: 100%;
        text-align: center;
        position: relative;
    }
    .button-wrapper {
        text-align: center; 
        width: 100%; 
        text-decoration: inherit;
        display: block;
        position: relative;
    }

    /* mobile screen only */
    @media only screen and (max-width: 700px) {
        .row-column {
            min-width: 100% !important;
        }
        /* hide any non-mobile elements */
        .no-mobile {
            display: none !important;
        }
        .section,
        .section-rows,
        .row,
        .row-inner,
        .main-page {
            min-width: 100% !important;
            max-width: 100% !important;
        }
        .main-page-main-table {
            margin: 0 !important;
            min-width: 100% !important;
            max-width: 100% !important;
        }
    }
    /* tablet screen only */
    @media only screen and (max-width: 1000px) and (min-width: 700px) {
        .row-column {
            /*min-width: 100%;*/
        }
        /* hide any non-tablet and non-mobile elements */
        .no-tablet {
            display: none !important;
        }
    }
    /* desktop screen only */
    @media only screen and (min-width: 1000px) {
        .row-column {
            /*min-width: 100%;*/
        }
        /* hide any non-tablet and non-mobile elements */
        .no-desktop {
            display: none !important;
        }
    }

    .container {
        overflow-wrap: anywhere;
    }
    table, tr, td, tbody {
        display: block;
        overflow-wrap: anywhere;
    }

    .ql-font-arial { font-family: "Arial" }
    .ql-font-arialblack { font-family: "Arial Black" }
    .ql-font-couriernew { font-family: 'Courier New', monospace; }
    .ql-font-courier { font-family: 'Courier', monospace }
    .ql-font-comicsans { font-family: "Comic Sans MS" }
    .ql-font-droidsans { font-family: "Droid Sans" }
    .ql-font-georgia { font-family: "Georgia" }
    .ql-font-helvetica { font-family: Helvetica }
    .ql-font-lucidasans { font-family: "Lucida Sans" }
    .ql-font-opensans { font-family: "Open Sans" }
    .ql-font-roboto { font-family: "Roboto" }
    .ql-font-tahoma { font-family: 'Tahoma' }
    .ql-font-timesnewroman { font-family: 'Times New Roman' }
    .ql-font-trebuchetms { font-family: 'Trebuchet MS', sans-serif }
    .ql-font-verdana { font-family: 'Verdana' }
    .ql-font-garamond { font-family: 'Garamond', serif; }
    .ql-font-brushscriptmt { font-family: 'Brush Script MT', cursive; }

    .ql-font-lora { font-family: 'Nunito' }
	.ql-font-muli { font-family: 'Muli' }
	.ql-font-playfairdisplay { font-family: 'Playfair Display' }
	.ql-font-ubuntu { font-family: 'Ubuntu' }
	.ql-font-modak { font-family: 'Modak' }
	.ql-font-merriweather { font-family: 'Merriweather' }
	.ql-font-poppins { font-family: 'Poppins' }
	.ql-font-raleway { font-family: 'Raleway' }
	.ql-font-oswald { font-family: 'Oswald' }
	.ql-font-codacaption { font-family: 'Coda Caption' }
	.ql-font-montserrat { font-family: 'Montserrat' }
	.ql-font-odibeesans { font-family: 'Odibee Sans' }
	.ql-font-lato { font-family: 'Lato' }
	.ql-font-opensans { font-family: 'Open Sans' }
	.ql-font-lemonada { font-family: 'Lemonada' }
	.ql-font-sriracha { font-family: 'Sriracha' }
	.ql-font-roboto { font-family: 'Roboto' }
	.ql-font-sueellenfrancisco { font-family: 'Sue Ellen Francisco' }
	.ql-font-strait { font-family: 'Strait' }
	.ql-font-stoke { font-family: 'Stoke' }
	.ql-font-taviraj { font-family: 'Taviraj' }
	.ql-font-salsa { font-family: 'Salsa' }
	.ql-font-spacemono { font-family: 'Space Mono' }
	.ql-font-lindenhill { font-family: 'Linden Hill' }
	.ql-font-solway { font-family: 'Solway' }
	.ql-font-rochester { font-family: 'Rochester' }
	.ql-font-questrial { font-family: 'Questrial' }
	.ql-font-overtherainbow { font-family: 'Over the Rainbow' }
    .ql-font-proximanovacondensed { font-family: 'ProximaNovaCondensed' }
    .ql-font-abel{ font-family: "Abel"; } .ql-font-abrilfatface{ font-family: "Abril Fatface"; } .ql-font-acme{ font-family: "Acme"; } .ql-font-amaticsc{ font-family: "Amatic SC"; } .ql-font-anticslab{ font-family: "Antic Slab"; } .ql-font-anton{ font-family: "Anton"; } .ql-font-architectsdaughter{ font-family: "Architects Daughter"; } .ql-font-archivonarrow{ font-family: "Archivo Narrow"; } .ql-font-arimo{ font-family: "Arimo"; } .ql-font-arvo{ font-family: "Arvo"; } .ql-font-asap{ font-family: "Asap"; } .ql-font-assistant{ font-family: "Assistant"; } .ql-font-balsamiqsans{ font-family: "Balsamiq Sans"; } .ql-font-barlow{ font-family: "Barlow"; } .ql-font-barlowcondensed{ font-family: "Barlow Condensed"; } .ql-font-bebasneue{ font-family: "Bebas Neue"; } .ql-font-bitter{ font-family: "Bitter"; } .ql-font-breeserif{ font-family: "Bree Serif"; } .ql-font-cabin{ font-family: "Cabin"; } .ql-font-cairo{ font-family: "Cairo"; } .ql-font-catamaran{ font-family: "Catamaran"; } .ql-font-caveat{ font-family: "Caveat"; } .ql-font-comfortaa{ font-family: "Comfortaa"; } .ql-font-cormorantgaramond{ font-family: "Cormorant Garamond"; } .ql-font-crimsontext{ font-family: "Crimson Text"; } .ql-font-dancingscript{ font-family: "Dancing Script"; } .ql-font-dmsans{ font-family: "DM Sans"; } .ql-font-dosis{ font-family: "Dosis"; } .ql-font-ebgaramond{ font-family: "EB Garamond"; } .ql-font-exo2{ font-family: "Exo 2"; } .ql-font-firasans{ font-family: "Fira Sans"; } .ql-font-fjallaone{ font-family: "Fjalla One"; } .ql-font-fredokaone{ font-family: "Fredoka One"; } .ql-font-heebo{ font-family: "Heebo"; } .ql-font-hind{ font-family: "Hind"; } .ql-font-hindmadurai{ font-family: "Hind Madurai"; } .ql-font-hindsiliguri{ font-family: "Hind Siliguri"; } .ql-font-ibmplexsans{ font-family: "IBM Plex Sans"; } .ql-font-ibmplexserif{ font-family: "IBM Plex Serif"; } .ql-font-inconsolata{ font-family: "Inconsolata"; } .ql-font-indieflower{ font-family: "Indie Flower"; } .ql-font-inter{ font-family: "Inter"; } .ql-font-josefinsans{ font-family: "Josefin Sans"; } .ql-font-kanit{ font-family: "Kanit"; } .ql-font-karla{ font-family: "Karla"; } .ql-font-lato{ font-family: "Lato"; } .ql-font-librebaskerville{ font-family: "Libre Baskerville"; } .ql-font-librefranklin{ font-family: "Libre Franklin"; } .ql-font-lobster{ font-family: "Lobster"; } .ql-font-lora{ font-family: "Lora"; } .ql-font-martel{ font-family: "Martel"; } .ql-font-merriweather{ font-family: "Merriweather"; } .ql-font-merriweathersans{ font-family: "Merriweather Sans"; } .ql-font-montserrat{ font-family: "Montserrat"; } .ql-font-mukta{ font-family: "Mukta"; } .ql-font-nanumgothic{ font-family: "Nanum Gothic"; } .ql-font-notosans{ font-family: "Noto Sans"; } .ql-font-notosanshk{ font-family: "Noto Sans HK"; } .ql-font-notosansjp{ font-family: "Noto Sans JP"; } .ql-font-notosanskr{ font-family: "Noto Sans KR"; } .ql-font-notosanssc{ font-family: "Noto Sans SC"; } .ql-font-notosanstc{ font-family: "Noto Sans TC"; } .ql-font-notoserif{ font-family: "Noto Serif"; } .ql-font-nunito{ font-family: "Nunito"; } .ql-font-nunitosans{ font-family: "Nunito Sans"; } .ql-font-opensans{ font-family: "Open Sans"; } .ql-font-oswald{ font-family: "Oswald"; } .ql-font-overpass{ font-family: "Overpass"; } .ql-font-oxygen{ font-family: "Oxygen"; } .ql-font-pacifico{ font-family: "Pacifico"; } .ql-font-permanentmarker{ font-family: "Permanent Marker"; } .ql-font-play{ font-family: "Play"; } .ql-font-playfairdisplay{ font-family: "Playfair Display"; } .ql-font-poppins{ font-family: "Poppins"; } .ql-font-prompt{ font-family: "Prompt"; } .ql-font-ptsans{ font-family: "PT Sans"; } .ql-font-ptsansnarrow{ font-family: "PT Sans Narrow"; } .ql-font-ptserif{ font-family: "PT Serif"; } .ql-font-questrial{ font-family: "Questrial"; } .ql-font-quicksand{ font-family: "Quicksand"; } .ql-font-rajdhani{ font-family: "Rajdhani"; } .ql-font-raleway{ font-family: "Raleway"; } .ql-font-roboto{ font-family: "Roboto"; } .ql-font-robotocondensed{ font-family: "Roboto Condensed"; } .ql-font-robotomono{ font-family: "Roboto Mono"; } .ql-font-robotoslab{ font-family: "Roboto Slab"; } .ql-font-rubik{ font-family: "Rubik"; } .ql-font-shadowsintolight{ font-family: "Shadows Into Light"; } .ql-font-signika{ font-family: "Signika"; } .ql-font-slabo27px{ font-family: "Slabo 27px"; } .ql-font-sourcecodepro{ font-family: "Source Code Pro"; } .ql-font-sourcesanspro{ font-family: "Source Sans Pro"; } .ql-font-sourceserifpro{ font-family: "Source Serif Pro"; } .ql-font-teko{ font-family: "Teko"; } .ql-font-titilliumweb{ font-family: "Titillium Web"; } .ql-font-ubuntu{ font-family: "Ubuntu"; } .ql-font-varelaround{ font-family: "Varela Round"; } .ql-font-worksans{ font-family: "Work Sans"; } .ql-font-yanonekaffeesatz{ font-family: "Yanone Kaffeesatz"; } .ql-font-zillaslab{ font-family: "Zilla Slab"; } 
    `
}
